export const BASE_URL: string = process.env.REACT_APP_API_KEY || "";
// export const BASE_URL: string = "http://178.128.61.122:8090";

export const ADMIN_ORDER_FIND_MANY: string =
  BASE_URL + "/order/admin/find-many";
export const ADMIN_ORDER_FIND_ONE: string = BASE_URL + "/order/admin/find-one";
export const ADMIN_ORDER_UPDATE_STATUS: string =
  BASE_URL + "/order/admin/update-status";
  export const ADMIN_ORDER_UPDATE:string=BASE_URL+"/order/admin/udpate";
  export const ORDER_ADMIN_SUMMARY:string=BASE_URL+"/order/admin/summary";
export const ORDER_ADMIN_FIND_ONE:string=BASE_URL+"/order/admin/find-one";
export const ORDER_ADMIN_FIND_ORDER_LOG:string=BASE_URL+"/order/admin/find-many-order-log";
